import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.hemlo.cc/finances#donate",
  target: "_blank"
}, "Donate", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://github.com/man90es/Genshin-Party-Builder",
  target: "_blank"
}, "GitHub", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Man90's Genshin Party Builder is not affiliated with or endorsed by miHoYo.", -1)

import { useJsonDataStore } from "@/stores"

	
export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props) {

	const jsonData = useJsonDataStore()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", null, [
    (_unref(jsonData).version)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Data v" + _toDisplayString(_unref(jsonData).version), 1))
      : _createCommentVNode("", true),
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
}
}

})